(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ys-experimental-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializePanels = (root) => {
      if (root.dataset.ys5XpanelsReady === 'true') return;
      root.dataset.ys5XpanelsReady = 'true';
      const panels = [...root.querySelectorAll('[data-ys5-xpanel]')];

      const activate = (selected) => {
        panels.forEach((panel) => {
          const active = panel === selected;
          panel.classList.toggle('is-active', active);
          panel.querySelector('.ys5-xpanel__trigger')?.setAttribute('aria-pressed', String(active));
        });
      };

      panels.forEach((panel) => {
        const trigger = panel.querySelector('.ys5-xpanel__trigger');
        trigger?.addEventListener('click', () => activate(panel));
        panel.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse') activate(panel);
        });
        panel.addEventListener('focusin', () => activate(panel));
      });
    };

    document.querySelectorAll('[data-ys5-xpanels]').forEach(initializePanels);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-ys5-xpanels]').forEach(initializePanels);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ys-why-stack"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeWhyDeck = (root) => {
      if (root.dataset.ysWhyReady === 'true') return;
      root.dataset.ysWhyReady = 'true';
      const deck = root.querySelector('[data-ys-why-deck]');
      const cards = [...root.querySelectorAll('[data-ys-why-card]')];
      const dots = [...root.querySelectorAll('[data-ys-why-dot]')];
      if (!deck || cards.length === 0) return;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const controller = new AbortController();
      let activeIndex = 0;
      let pointerStart = 0;
      let locked = false;
      let transitionTimer = 0;
      let autoplayTimer = 0;
      let autoplayPaused = false;
      const autoplayDelay = 5600;

      const render = () => {
        cards.forEach((card, index) => {
          const distance = (index - activeIndex + cards.length) % cards.length;
          card.dataset.position = distance < 3 ? String(distance) : 'hidden';
          const active = distance === 0;
          card.classList.toggle('is-active', active);
          card.setAttribute('aria-hidden', String(!active));
        });
        dots.forEach((dot, index) => {
          const active = index === activeIndex;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };

      const scheduleAutoplay = () => {
        window.clearTimeout(autoplayTimer);
        if (reduceMotion.matches || autoplayPaused || document.hidden) return;
        autoplayTimer = window.setTimeout(() => {
          show(activeIndex + 1, 1);
          scheduleAutoplay();
        }, autoplayDelay);
      };

      const pauseAutoplay = () => {
        autoplayPaused = true;
        window.clearTimeout(autoplayTimer);
      };

      const resumeAutoplay = () => {
        autoplayPaused = false;
        scheduleAutoplay();
      };

      const show = (index, direction = 1) => {
        if (locked || index === activeIndex) return;
        const finish = () => {
          cards[activeIndex].classList.remove('is-leaving-left', 'is-leaving-right');
          activeIndex = (index + cards.length) % cards.length;
          render();
          locked = false;
        };
        if (reduceMotion.matches) {
          finish();
          return;
        }
        locked = true;
        cards[activeIndex].classList.add(direction > 0 ? 'is-leaving-left' : 'is-leaving-right');
        transitionTimer = window.setTimeout(finish, 330);
      };

      root.querySelector('[data-ys-why-next]')?.addEventListener('click', () => { pauseAutoplay(); show(activeIndex + 1, 1); }, { signal: controller.signal });
      root.querySelector('[data-ys-why-prev]')?.addEventListener('click', () => { pauseAutoplay(); show(activeIndex - 1, -1); }, { signal: controller.signal });
      dots.forEach((dot, index) => dot.addEventListener('click', () => { pauseAutoplay(); show(index, index > activeIndex ? 1 : -1); }, { signal: controller.signal }));
      deck.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          pauseAutoplay();
          show(activeIndex - 1, -1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          pauseAutoplay();
          show(activeIndex + 1, 1);
        }
      }, { signal: controller.signal });
      deck.addEventListener('pointerdown', (event) => {
        pointerStart = event.clientX;
      }, { passive: true, signal: controller.signal });
      deck.addEventListener('pointerup', (event) => {
        const distance = event.clientX - pointerStart;
        if (Math.abs(distance) < 45) return;
        pauseAutoplay();
        show(activeIndex + (distance < 0 ? 1 : -1), distance < 0 ? 1 : -1);
      }, { passive: true, signal: controller.signal });
      root.addEventListener('mouseenter', pauseAutoplay, { signal: controller.signal });
      root.addEventListener('mouseleave', resumeAutoplay, { signal: controller.signal });
      root.addEventListener('focusin', pauseAutoplay, { signal: controller.signal });
      root.addEventListener('focusout', (event) => {
        if (!root.contains(event.relatedTarget)) resumeAutoplay();
      }, { signal: controller.signal });
      document.addEventListener('visibilitychange', scheduleAutoplay, { signal: controller.signal });
      reduceMotion.addEventListener?.('change', scheduleAutoplay, { signal: controller.signal });

      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(root)) return;
        window.clearTimeout(transitionTimer);
        window.clearTimeout(autoplayTimer);
        controller.abort();
      }, { signal: controller.signal });
      render();
      scheduleAutoplay();
    };

    document.querySelectorAll('[data-ys-why]').forEach(initializeWhyDeck);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-ys-why]').forEach(initializeWhyDeck);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
